import { render, staticRenderFns } from "./PrePhoto.vue?vue&type=template&id=40b389e6&scoped=true"
import script from "./PrePhoto.vue?vue&type=script&lang=js"
export * from "./PrePhoto.vue?vue&type=script&lang=js"
import style0 from "./PrePhoto.vue?vue&type=style&index=0&id=40b389e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b389e6",
  null
  
)

export default component.exports